import React, { useState } from "react";
import { Redirect } from "react-router";
// import { StartupPageTemplate } from "../components/startup-pages/StartupPageTemplate";
import { SetupPageTemplate } from "../components/setup-pages/SetupPageTemplate";
import { dashboard } from "../configs/routes";

import { CountdownCircleTimer } from "react-countdown-circle-timer";

export const LoadingData = (props) => {
	const [redirecting, setRedirecting] = useState(false);

	const renderTime = ({ remainingTime }) => {
		if (remainingTime === 0) {
			return <div className="timer">Ready</div>;
		}

		return (
			<div className="flex flex-col justify-center text-center">
				<div className="text-base text-slate-400">Remaining</div>
				<div className="text-xl text-slate-800">{remainingTime}</div>
				<div className="text-base text-slate-400">"seconds"</div>
			</div>
		);
	};

	const onComplete = () => {
		setRedirecting(true);
	};

	if (redirecting) {
		return (
			<Redirect
				to={{
					pathname: dashboard,
					state: { isDemoUser: props.location?.state?.isDemoUser },
				}}
			/>
		);
	}

	return (
		<SetupPageTemplate headerDetails={{ title: "Finalising your account" }}>
			<div className={"px-2 md:px-0 text-black text-sm lg:text-base"}>
				<h2 className={"text-lg pt-6 pb-1 font-bold mb-2 text-center"}>
					Preparing your data
				</h2>

				<div className="mt-2 text-center">
					Please wait a few seconds while we set everything up for you.
				</div>

				<div
					className={
						"flex flex-grow overflow-y-auto px-6 pt-2 sm:px-8 sm:pt-8 pb-28 mt-8 justify-center"
					}
				>
					<CountdownCircleTimer
						isPlaying
						duration={5}
						colors={["#FF0000", "#FF6600", "#33CC33"]}
						colorsTime={[5, 3, 0]}
						onComplete={onComplete}
					>
						{renderTime}
					</CountdownCircleTimer>
				</div>
			</div>
		</SetupPageTemplate>
	);
};
